import React, { useEffect, useState } from 'react'
import styles from './styles.module.scss'
import responsiveStyles from './responsiveStyles.module.scss'
import { Report } from 'notiflix/build/notiflix-report-aio'

import { titleData } from '../../../data/titles'
import { contactPreferencesData } from '../../../data/contactPreferences'
import {
    InputFieldText,
    InputFieldSelect,
    FieldGroup,
    Field,
    SubmitButton,
    ButtonContainer,
    FieldContainer,
    FormCard,
} from '../../reusable'

import { FormPartInterface, SaveValueInterface } from '../../../interfaces'
import { Checkbox } from '../../reusable/checkbox'
import { InputFieldAddressLookup } from '../../reusable/inputFieldAddressLookup'
import { lenderData } from '../../../data/lenders'
import { SignaturePad } from '../../reusable/sigPad'
import { sectionValidation } from '../../../helpers'
import { browserName, osName, deviceDetect, getUA } from 'react-device-detect'
import { useClaimData } from '../../../claimProvider'
import Previewer from '../../reusable/previewer'
import { useNavigate } from 'react-router-dom'
import { useUpdateClaimData } from '../../../claimProvider'

export const SignatureSentinel = (props: FormPartInterface) => {
    const { saveValueFunct, isActive, assignGroup, validateSection } = props
    const [currentStep, setCurrentStep] = useState(0)
    const [postCurrentStep, setPostCurrentStep] = useState(0)
    const [stepData, setStepData] = useState<any>({})
    // const [cases, setCases] = useState<any>([{ leadData: { lender: "audi finance", case_ref: "pcpSNT_234" }, cfaUrl: "T", loaUrl: "YT" }]);
    // const [cases, setCases] = useState<any>([])
    const [sigLinkToken, setSigLinkToken] = useState<string>('')
    const claim = useClaimData()
    const updateClaim = useUpdateClaimData()
    const navigate = useNavigate()

    useEffect(() => {
        console.log('Current claim data:', claim)
    }, [claim])

    const preSaveValueFunct = (dataToSave: SaveValueInterface) => {
        const saved = saveValueFunct(dataToSave)
        let tempStepData = stepData
        tempStepData[dataToSave.field] = dataToSave.value
        setStepData(tempStepData)
        return saved
    }

    const animateBeforeAssign = (assignment: string) => {
        console.log('Step data:', stepData)

        if (!sectionValidation(stepData, 'signature').success) return
        setTimeout(() => {
            assignGroup('complete')
            navigate('thankyou')
        }, 400)
    }

    const getCurrentStep = () => {
        return isActive == 'signature' ? (
            <FieldGroup title="Sign Your Letter of Authority">
                <FormCard assignPostStep={setPostCurrentStep} step={currentStep} onBack={() => assignGroup('confirm')}>
                    <div className={`${styles.sentinelSig} ${responsiveStyles.sentinelSig}`}>
                        <h3 className={`${styles.topTitle} ${responsiveStyles.topTitle}`}>
                            Please review and sign your documents instructing Sentinel Legal to act on your behalf.
                        </h3>
                        <br />
                        <Checkbox
                            fieldName={'acceptTerms'}
                            label={
                                'I agree that I have read, understand and accept the Sentinel Legal terms of business and that the check is free. I also agree to instruct Sentinel Legal to send a data subject access request (DSAR) to find out if my PCP or HP agreements were mis-sold.'
                            }
                            saveValue={preSaveValueFunct}
                        />
                        <br />
                        <SignaturePad
                            extraPayload={{
                                browser: browserName,
                                device: osName,
                                type: claim.leadOrigin,
                                claim,
                            }}
                            additionalAction={() => animateBeforeAssign('complete')}
                            disclaimer="*By signing this document, you agree that Sentinel Legal can do a soft credit check to look at your car finance deal, check who you are, and stop money laundering. This check won't affect your credit score, and we will only look at information about your car finance. You also agree that Sentinel Legal can use your signature to complete all claims we find in your name. This will allow us to fill out and send the necessary forms for each claim. Your signature will only be used for claims linked to you, and you can ask us to stop using it at any time."
                        />
                        <br />
                        <div>
                            <h3>Your Claims</h3>
                            {claim && (
                                <div className={`${styles.singleClaim} ${responsiveStyles.singleClaim}`}>
                                    <p className={styles.claimTitle}>Your Details</p>

                                    <p>
                                        <span>Finance Provider:</span> TBC
                                    </p>
                                    {claim.leadData?.case_ref && (
                                        <p>
                                            <span>Sentinel Reference:</span> {claim.leadData.case_ref}
                                        </p>
                                    )}
                                    <p className={styles.claimTitle}>Your Documents</p>
                                    <div>
                                        {claim?.loaUrl ? (
                                            <Previewer url={claim.loaUrl} documentString={'LOA'} />
                                        ) : (
                                            <></>
                                        )}
                                        {claim?.cfaUrl ? (
                                            <Previewer url={claim.cfaUrl} documentString={'CFA'} />
                                        ) : (
                                            <></>
                                        )}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </FormCard>
            </FieldGroup>
        ) : (
            <></>
        )
    }

    return getCurrentStep()
}
